import { Send, FileText, ScanSearch } from "lucide-react";

const STEPS = [
  {
    n: "01",
    icon: Send,
    title: "Anfrage stellen",
    text: "Senden Sie mir den Link zur Bewertung sowie kurze Hintergrund­informationen. Innerhalb von 12–24 Stunden erhalten Sie eine kostenfreie Ersteinschätzung.",
  },
  {
    n: "02",
    icon: FileText,
    title: "Meldung strukturiert einreichen",
    text: "Ich bereite Ihre Meldung professionell auf und reiche sie über das offizielle Formular der jeweiligen Plattform ein. Sie erhalten eine Bestätigung der Einreichung.",
  },
  {
    n: "03",
    icon: ScanSearch,
    title: "Prüfung durch die Plattform",
    text: "Die inhaltliche Prüfung sowie die finale Entscheidung über eine Entfernung erfolgt ausschließlich durch die jeweilige Plattform.",
  },
];

export default function Process() {
  return (
    <section id="ablauf" data-testid="process-section" className="relative py-20 lg:py-28 border-t border-black/[0.05]">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="max-w-2xl">
          <div className="text-xs font-bold uppercase tracking-[0.2em] text-[#2b2620]">So funktioniert der Ablauf</div>
          <h2 className="mt-4 font-heading text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight text-[#2b2620]">
            Drei klare Schritte. Keine Überraschungen.
          </h2>
        </div>

        <div className="mt-14 relative">
          <div className="hidden lg:block absolute top-12 left-[8%] right-[8%] h-px bg-gradient-to-r from-transparent via-[#2b2620]/30 to-transparent" />
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 relative">
            {STEPS.map(({ n, icon: Icon, title, text }, i) => (
              <div
                key={n}
                data-testid={`process-step-${i + 1}`}
                className="bg-[#faf6ef] border border-black/[0.08] rounded-3xl p-8 hover:border-[#2b2620]/30 transition-all"
              >
                <div className="flex items-center justify-between">
                  <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-[#2b2620] to-[#6b6c75] text-white flex items-center justify-center">
                    <Icon className="w-6 h-6" />
                  </div>
                  <span className="font-heading text-4xl font-semibold text-[#2b2620]/10">{n}</span>
                </div>
                <h3 className="mt-6 font-heading text-xl font-medium text-[#2b2620]">{title}</h3>
                <p className="mt-3 text-sm text-[#6b5f52] leading-relaxed">{text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
